module.exports = __webpack_public_path__ + "media/demo.c6bb95b8.mp4";